import { api } from '@api/api2';
import type { GetResidentAccountOwnerPayload } from './types';

export const getResidentAccountOwner = (payload: GetResidentAccountOwnerPayload) =>
  api.v4('get', 'personal-account/relation/resident/list', payload);
